import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError } from "@/lib/api";
import { StatusPill, Thread } from "./TicketParts";

const field = "h-12 rounded-xl border-slate-300 bg-white text-slate-900 placeholder:text-slate-400";

const readLast = () => {
  try {
    return JSON.parse(localStorage.getItem("sate_last_ticket")) || { code: "", email: "" };
  } catch {
    return { code: "", email: "" };
  }
};

export const TicketLookup = ({ prefill }) => {
  const [q, setQ] = useState(readLast);
  const [ticket, setTicket] = useState(null);
  const [reply, setReply] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (prefill) setQ(prefill);
  }, [prefill]);

  const call = async (path, body) => {
    setBusy(true);
    try {
      const { data } = await api.post(path, body);
      setTicket(data);
      return true;
    } catch (err) {
      toast.error(formatApiError(err));
      return false;
    } finally {
      setBusy(false);
    }
  };

  const lookup = (e) => { e.preventDefault(); call("/tickets/lookup", q); };
  const sendReply = async (e) => {
    e.preventDefault();
    if (await call("/tickets/reply", { ...q, message: reply })) { setReply(""); toast.success("Reply sent"); }
  };

  return (
    <div className="space-y-6">
      <form onSubmit={lookup} className="grid gap-3 sm:grid-cols-[1fr_1.4fr_auto]" data-testid="ticket-lookup-form">
        <Input required placeholder="TCK-12345" value={q.code} onChange={(e) => setQ({ ...q, code: e.target.value })} className={`${field} font-mono-x uppercase`} data-testid="ticket-lookup-input" />
        <Input required type="email" placeholder="Email used on ticket" value={q.email} onChange={(e) => setQ({ ...q, email: e.target.value })} className={field} data-testid="ticket-lookup-email-input" />
        <button disabled={busy} data-testid="ticket-lookup-button" className="inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-blue-600 px-5 text-sm font-bold text-white transition-colors hover:bg-blue-700 disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />} Track
        </button>
      </form>
      {ticket && (
        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5" data-testid="ticket-lookup-result">
          <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
            <div><p className="font-mono-x text-xs font-bold text-blue-600" data-testid="ticket-result-code">{ticket.code}</p><p className="font-display text-lg font-bold text-slate-900">{ticket.subject}</p></div>
            <StatusPill status={ticket.status} testId="ticket-result-status" />
          </div>
          <Thread ticket={ticket} />
          {ticket.status !== "closed" && (
            <form onSubmit={sendReply} className="mt-5 space-y-3">
              <Textarea required rows={3} placeholder="Add a reply…" value={reply} onChange={(e) => setReply(e.target.value)} className="rounded-xl border-slate-300 bg-white text-slate-900 placeholder:text-slate-400" data-testid="ticket-customer-reply-input" />
              <button disabled={busy} data-testid="ticket-customer-reply-button" className="rounded-full bg-blue-600 px-5 py-2.5 text-sm font-bold text-white disabled:opacity-60">Send reply</button>
            </form>
          )}
        </div>
      )}
    </div>
  );
};
